import { z } from "zod";

export const ICON_TYPES = [
  "badge-check",
  "bell-solid",
  "binoculars",
  "book",
  "bookmark",
  "briefcase",
  "briefcase-outlined",
  "building",
  "building-thick",
  "calendar",
  "calendar-day",
  "caret-bottom",
  "caret-double-left",
  "caret-double-right",
  "centered-circle",
  "chart-line-increase",
  "chevron-down",
  "chevron-left",
  "chevron-right",
  "chevron-up",
  "clock",
  "clock-back",
  "clock-outlined",
  "close",
  "cogwheel",
  "coordinates-person",
  "clipboard-bunny-gold",
  "dash",
  "dollar",
  "door-straight",
  "ellipsis",
  "files",
  "filter",
  "folder-person",
  "folder-view",
  "gauge",
  "gps-disabled",
  "group",
  "house-building",
  "hybrid-view",
  "hyperlink",
  "identity-card",
  "information",
  "information-circle",
  "location-alt",
  "magnifying-glass",
  "map-pin",
  "map-pin-filled",
  "medal-star-alt",
  "message",
  "microscope",
  "minus",
  "money-dollar",
  "notepad-alt",
  "notepad-problem",
  "padlock-locked",
  "palm-dollar",
  "pencil",
  "people",
  "person-male",
  "person-male-formal",
  "person-superstar",
  "plus",
  "profile",
  "question-circle",
  "replay",
  "ribbon",
  "route",
  "sorted-ascending-arrows",
  "sorted-descending-arrows",
  "stack-vertical",
  "student",
  "trash",
  "triangle-down",
  "triangles-dots-horizontal-collapse",
  "triangles-dots-horizontal-expand",
  "unsorted-arrows",
  "variant",
  "warning",
] as const;

export type IconType = typeof ICON_TYPES[number];

export const iconTypeSchema = z.enum(ICON_TYPES);
